/* tslint:disable */

declare var Object: any;
export interface SurveyInterface {
  "name": string;
  "link": string;
  "description"?: string;
  "id"?: number;
}

export class Survey implements SurveyInterface {
  "name": string;
  "link": string;
  "description": string;
  "id": number;
  constructor(data?: SurveyInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Survey`.
   */
  public static getModelName() {
    return "Survey";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Survey for dynamic purposes.
  **/
  public static factory(data: SurveyInterface): Survey{
    return new Survey(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Survey',
      plural: 'surveys',
      path: 'surveys',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "link": {
          name: 'link',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/Survey.ts